import React, { useEffect, useContext } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { string, shape, bool } from 'prop-types';
import { Helmet } from 'react-helmet';
import { Route } from 'react-router-dom';
import { withRouter } from 'react-router';
import i18next from 'i18next';

import { MODALS } from '~redux/Modal/constants';
import { getOgMetaTags, completeOgObject } from '~utils/seo';
import Footer from '~screens/Commerce/components/Footer';
import Navbar from '~screens/Commerce/components/Navbar';
import TopSiteMessage from '~screens/Commerce/components/TopSiteMessage';
import SmartBanner from '~app/components/SmartBanner';
import SmartbannerContext from '~screens/Commerce/contexts/SmartbannerContext/context';

import styles from './styles.module.scss';

const AuthenticatedRoute = ({
  title,
  description,
  path,
  noNavbar,
  noCartFooter,
  noFooter,
  appsLinks = {},
  ...props
}) => {
  const TopSiteMessageisOpen = useSelector((state) => state.modal[MODALS.TOP_SITE_MESSAGE]?.open);
  useEffect(() => window.scrollTo({ top: 0, behavior: 'smooth' }), []);
  const { isSmartbannerActive, setIsSmartbannerActive } = useContext(SmartbannerContext);

  // eslint-disable-next-line complexity
  const ogTags = getOgMetaTags(completeOgObject({ title, description, path }));
  const { templateModel } = useSelector((state) => state.core);
  return (
    <>
      <Helmet>
        <title>{title}</title>
        {ogTags}
      </Helmet>
      <div className={cn(styles.containerSite, 'item-1')}>
        {TopSiteMessageisOpen && <TopSiteMessage />}

        <SmartBanner
          isSmartbannerActive={isSmartbannerActive}
          setIsSmartbannerActive={setIsSmartbannerActive}
          appsLinks={appsLinks}
          title={i18next.t('Commerce:downloadOurApp')}
          button={i18next.t('Commerce:download')}
        />

        {!noNavbar && <Navbar {...(TopSiteMessageisOpen && { topSiteMessage: true })} />}
        <div
          id="site-content"
          className={cn('column center full-width full-height', {
            [`${styles[`mainContent${templateModel}`]}`]: !noNavbar,
            [styles.topSiteMessage]: TopSiteMessageisOpen
          })}>
          <Route path={path} {...props} />
        </div>
      </div>
      {!noFooter && <Footer noCartFooter={noCartFooter} />}
    </>
  );
};

AuthenticatedRoute.defaultProps = {
  noCartFooter: false,
  noFooter: false,
  noNavbar: false
};

AuthenticatedRoute.propTypes = {
  path: string.isRequired,
  appsLinks: shape({
    name: string,
    content: string
  }),
  description: string,
  location: shape({
    pathname: string
  }),
  noCartFooter: bool,
  noFooter: bool,
  noNavbar: bool,
  title: string
};

export default withRouter(AuthenticatedRoute);
